'use client';

import type { FC } from 'react';

import { ScrollTopButton } from '@packages/modules/src/ScrollTopButton/ScrollTopButton';

/**
 * Scroll to top button for search pages (MBA, SERP and ZeroResultsPage)
 * */
export const SearchScrollTopButton: FC = () => (
  <div className="z-app-bar fixed right-[2%] bottom-4">
    <ScrollTopButton />
  </div>
);
